import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';

const ModalPassword = ({
  showPasswordModal,
  ventaPendiente,
  password,
  setPassword,
  enviandoVenta,
  confirmarVentaConPassword,
  onCancel,
  title = 'Autorización de administrador',
  description = 'Ingresá el PIN para continuar.',
  details,
  errorMessage
}) => {
  const totalClientes = ventaPendiente?.cantidad ?? 0;
  const totalMonto = ventaPendiente?.valor ?? 0;
  const passwordInvalida = password.trim().length === 0;

  return (
    showPasswordModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4 pointer-events-auto">
        <motion.div
          className="w-full max-w-md rounded-2xl border border-emerald-500/25 bg-zinc-900/95 p-6 md:p-7 shadow-2xl shadow-black/40"
          initial={{ scale: 0.95, opacity: 0, y: 10 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          <div className="mb-5 flex items-start gap-3">
            <span className="mt-0.5 rounded-full bg-emerald-500/15 p-2 text-emerald-400">
              <Lock size={20} />
            </span>
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-white">{title}</h3>
              <p className="mt-1 text-sm text-zinc-300">{description}</p>
            </div>
          </div>

          <p className="mb-4 text-sm md:text-base leading-relaxed text-zinc-200">
            {details || `Se confirmará la venta de ${totalClientes} entrada${totalClientes === 1 ? '' : 's'} por $${totalMonto.toFixed(2)} y quedará asignada a tu usuario.`}
          </p>

          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              e.stopPropagation();
            }}
            className="mb-5 w-full rounded-xl border border-zinc-700 bg-zinc-950/80 px-4 py-3 text-white placeholder-zinc-500 outline-none transition-colors focus:border-emerald-400 focus:ring-2 focus:ring-emerald-500/30"
            placeholder="PIN de administrador"
            autoFocus
            inputMode="numeric"
            autoComplete="off"
            ref={(input) => input && input.focus()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !passwordInvalida) confirmarVentaConPassword();
              e.stopPropagation();
            }}
            disabled={enviandoVenta}
          />

          {errorMessage && (
            <p className="mb-4 rounded-lg border border-red-400/30 bg-red-500/10 px-3 py-2 text-sm text-red-200">
              {errorMessage}
            </p>
          )}

          <div className="flex justify-end gap-3">
            <button
              onClick={() => {
                onCancel?.();
              }}
              disabled={enviandoVenta}
              className="rounded-xl border border-zinc-600 bg-zinc-800 px-4 py-2 text-white transition-colors hover:bg-zinc-700"
            >
              Cancelar
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                confirmarVentaConPassword();
              }}
              disabled={passwordInvalida || enviandoVenta}
              className={`rounded-xl px-4 py-2 font-medium text-white transition-colors ${
                passwordInvalida || enviandoVenta
                  ? 'cursor-not-allowed bg-zinc-600 opacity-70'
                  : 'bg-emerald-500 hover:bg-emerald-400'
              }`}
            >
              {enviandoVenta ? 'Confirmando...' : 'Confirmar'}
            </button>
          </div>
        </motion.div>
      </div>
    )
  );
};

export default ModalPassword;
